<template>
  <!-- Clinic and Specialities -->
  <section class="section section-specialities">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-md-9">
          <!-- Slider -->
          <slick
            class="specialities-slider slider addcursor"
            ref="slick"
            :options="slickOptions"
          >
            <!-- Slider Item -->
            <div
              class="speicality-item text-center"
              :class="{ active: activeitem === index }"
              v-for="(item, index) in specialities"
              :key="index"
            >
              <div class="speicality-img" @click="activeImage(index)">
                <img
                  :src="'https://develop-physio.kneexpert.in' + item.image"
                  class="img-fluid"
                  alt="Speciality"
                />
                <span><i class="fa fa-circle" aria-hidden="true"></i></span>
              </div>
              <p>{{ item.category_name }}</p>
            </div>
            <!-- /Slider Item -->
          </slick>
          <!-- /Slider -->
        </div>
      </div>
    </div>
  </section>
  <!-- Clinic and Specialities -->
</template>
<script>
const images = require.context(
  "@/assets/img/specialities",
  false,
  /\.png$|\.jpg$/
);
export default {
  data() {
    return {
      activeitem: undefined,
      slickOptions: {
        slidesToShow: 1,
        infinite: false,
        dots: true,
        arrows: false,
        swipeToSlide: true,
        variableWidth: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
    };
  },
  props: {
    specialities: { type: Array },
  },
  methods: {
    next() {
      this.$refs.slick.next();
    },
    prev() {
      this.$refs.slick.prev();
    },
    reInit() {
      this.$nextTick(() => {
        this.$refs.slick.reSlick();
      });
    },
    loadImg(imgPath) {
      return images("./" + imgPath);
    },
    activeImage(id) {
      if (this.activeitem == id) {
        this.activeitem = undefined;
      } else {
        this.activeitem = id;
      }
    },
  },
};
</script>

<style scoped>
.active {
  border: 2px solid #40e0fe;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Specialities.vue